<div class="mt-5"></div>

<div class="container-fluid">
    <div *ngIf="endId == 2 || endId == 3" class=" mt-5 d-flex justify-content-center text-center align-items-center">
        <em class="fa fa-check-circle fa-2x blink fa-5x text-success" aria-hidden="true"></em>
    </div>
    <div *ngIf="endId == 1" class=" mt-5 d-flex justify-content-center text-center align-items-center">
        <em class="fa fa-exclamation-triangle fa-2x blink fa-5x text-warning" aria-hidden="true"></em>
    </div>
    <div *ngIf="endId == 2" class=" mt-5 d-flex justify-content-center text-center align-items-center">
        <h5 class="mt-1">
            <strong>
                Thank you for attending! You've successfully left the meeting. If you have any further questions or need assistance, don't hesitate to ask. Have a wonderful day!
            </strong>
        </h5>
    </div>
    <div *ngIf="endId == 3" class=" mt-5 d-flex justify-content-center text-center align-items-center">
        <h5 class="mt-1">
            <strong>
                Thank you for your participation! The meeting has concluded successfully. If you have any follow-up questions or action items, feel free to reach out. Have a great day!
            </strong>
        </h5>
    </div>
    <div *ngIf="endId == 1" class=" mt-5 d-flex justify-content-center text-center align-items-center">
        <h5 class="mt-1">
            <strong>
                Apologies for any inconvenience!! but it seems you are already in meeting!!
            </strong>
        </h5>
    </div>

    <!-- <div class="mt-5 text-center">
        <button class="btn" (click)="routeToDashBoard()">
            Go To Home
        </button>
    </div> -->

</div>